import { createFileRoute } from "@tanstack/react-router";

import UsdaAudit from "~/pages/UsdaAudit";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/usda-audit")({
  staticData: ROUTE_STATIC.usdaAudit,
  component: UsdaAudit,
});
